module.exports = __webpack_public_path__ + "static/microsoft-powerapps-build-9e30b490e98ca1c069d6b20b621dfb0c.png";